import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import { Col, Form } from "react-bootstrap";

const TextAreaInput = ({ label, controlId, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <Form.Group
      as={Col}
      xs={props.xs}
      sm={props.sm}
      md={props.md}
      lg={props.lg}
      xl={props.xl}
      controlId={controlId}
      className={props.className ? props.className : "margin-bottom-1 "}
    >
      <Form.Label className={"text-input-label"}>{label}</Form.Label>
      <Form.Control
        as={"textarea"}
        className={"text-area " + (meta.touched && !!meta.error ? "error" : "")}
        isInvalid={meta.touched && !!meta.error}
        data-test-id={props.testId}
        {...field}
        {...props}
      />
      <Form.Control.Feedback type="invalid">{meta.touched && meta.error}</Form.Control.Feedback>
    </Form.Group>
  );
};

TextAreaInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  testId: PropTypes.string,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
};

export default TextAreaInput;
